import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BreadcrumbComponent } from './breadcrumb.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: BreadcrumbComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class BreadcrumbRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/view/breadcrumb/breadcrumb-routing.module.ts